import { Outlet } from "react-router-dom";
import { AuthModal } from "../auth/AuthModal";
import { SearchPalette } from "../search/SearchPalette";
import { SideRail } from "./SideRail";
import { useLiveStatus } from "./useLiveStatus";

// §11 App-Shell = NUR das äußere Chrome: links die Rail (Kategorien + App-Nav), rechts die
// geroutete Fläche (<Outlet>) + AuthModal + globale Suche (D123 — Overlay über ALLEN Routen,
// Studio UND Editor). Die in §11 beschriebene „4-Regionen-Arbeitsfläche"
// (Tabs / Media / Settings / RightSidebar) liegt NICHT hier, sondern in der gerouteten Seite
// pages/Studio.tsx — dort wird das Regionen-Grid aufgespannt.
export function AppShell() {
  useLiveStatus(); // D47 Live-Status-Push (WS) → Query-Invalidierung; realtime-only, kein Polling
  return (
    <div className="flex h-full w-full overflow-hidden">
      <SideRail />
      <main className="min-h-0 min-w-0 flex-1 overflow-hidden">
        <Outlet />
      </main>
      <AuthModal />
      <SearchPalette />
    </div>
  );
}
